<script>
import UtilsMixin from "@/mixins/utils";

export default {
  components: {},
  props: {
    data: Object,
    summary: Object,
    distributor: Object,
    me: Object,
  },
  data() {
    return {
      timePrint: {
        year: new Date().getFullYear(),
        month:
          new Date().getMonth() >= 10
            ? new Date().getMonth() + 1
            : `0${new Date().getMonth() + 1}`,
        day:
          new Date().getDate() >= 10
            ? new Date().getDate()
            : `0${new Date().getDate()}`,
        hour: new Date().getHours(),
        min: new Date().getMinutes(),
        sec: new Date().getSeconds(),
      },
    };
  },
  mixins: [UtilsMixin],
};
</script>

<template>
  <div class="page-landscape">
    <div class="d-flex justify-content-between">
      <div>
        <p class="text-uppercase mb-2 font-size-16">
          {{ distributor.distributor_name }}
        </p>
        <p class="text-uppercase mb-2 font-size-16">
          Địa chỉ: {{ distributor.distributor_address }}
        </p>
        <p class="text-uppercase mb-0 font-size-16">
          Tel: {{ distributor.distributor_phone }}
        </p>
      </div>
    </div>
    <h2 class="text-uppercase text-center pt-3">
      BÁO CÁO CHI TIẾT THU THEO ĐƠN HÀNG
    </h2>
    <div class="print-content">
      <p class="text-center">
        Từ ngày {{ formatDate(data.fromDate) }} đến ngày
        {{ formatDate(data.toDate) }}
      </p>
    </div>
    <table class="table table-bordered font-size-16 border-black">
      <tr>
        <th></th>
        <th colspan="4" class="font-weight-bold text-center">Chứng từ thu</th>
        <th colspan="3" class="font-weight-bold text-center">Đơn hàng</th>
      </tr>

      <tr>
        <th>Ngày chứng từ</th>
        <th>Số chứng từ</th>
        <th>Khách hàng</th>
        <th>Tổng tiền TT</th>
        <th>Tiền TT nợ cũ</th>
        <th>Phương thức TT</th>
        <th>Mã đơn</th>
        <th>Tổng tiền</th>
        <th>Tiền thanh toán</th>
        <th>Dư nợ sau TT</th>
      </tr>
      <tr v-for="(item, key) of data.details" :key="key">
        <td>{{ formatDate(item.payment_time) }}</td>
        <td>{{ item.payment_id }}</td>
        <td>{{ item.payer_name }}</td>
        <td>{{ formatPrice(item.total_amount) }}</td>
        <td>{{ formatPrice(item.old_debt_amount_paid) }}</td>
        <td>{{ item.payment_type }}</td>
        <td>{{ item.detail_document_id ? item.detail_document_id : "--" }}</td>
        <td>
          {{
            item.detail_total_amount || item.detail_total_amount === 0
              ? formatPrice(item.detail_total_amount)
              : "--"
          }}
        </td>
        <td>
          {{
            item.detail_payment_amount || item.detail_payment_amount === 0
              ? formatPrice(item.detail_payment_amount)
              : "--"
          }}
        </td>
        <td>
          {{
            item.detail_after_pay_amount || item.detail_after_pay_amount === 0
              ? formatPrice(item.detail_after_pay_amount)
              : "--"
          }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="font-weight-bold">Tổng</td>
        <td class="font-weight-bold">
          {{ formatPrice(data.dataSummary.summaryTotalAmount) }}
        </td>
        <td class="font-weight-bold">
          {{ formatPrice(data.dataSummary.summaryOldDebtAmountPaid) }}
        </td>
        <td></td>
        <td class="font-weight-bold">
          {{ formatPrice(data.dataSummary.summaryDetailTotalAmount) }}
        </td>
        <td class="font-weight-bold">
          {{ formatPrice(data.dataSummary.summaryDetailPaymentAmount) }}
        </td>
        <td class="font-weight-bold">
          {{ formatPrice(data.dataSummary.summaryDetailAfterPayAmount) }}
        </td>
      </tr>
      <tfoot class="footer-repeat no-border">
        <!-- add repeated tfoot for extra space -->
        <tr class="no-border">
          <td class="no-border">&nbsp;</td>
        </tr>
      </tfoot>
    </table>

    <div class="d-flex justify-content-end font-size-16 pt-3">
      <div>
        <p>
          Ngày {{ timePrint.day }} tháng {{ timePrint.month }} năm
          {{ timePrint.year }}
        </p>
        <p class="font-weight-medium text-center mb-0">Kế toán</p>
        <p class="font-italic text-center">(Ký, họ tên)</p>
      </div>
    </div>
  </div>
</template>
